import React from "react";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Form, Select, Tag, Tooltip } from "antd";
import { validateEmailAddress } from "@/utils/utils";
import { Validator } from "@/utils/validator";
const renderTag = ({ label, closable = true, onClose }) => {
    const isValid = validateEmailAddress(label);
    return (React.createElement(Tag, { color: isValid ? "blue" : "red", closable: closable, onClose: onClose, style: { marginRight: 3, justifySelf: "center", alignSelf: "center" } }, label));
};
const SecurePassMultiEmail = ({ name = "contactEmail", label = "Contact Emails", disabled = false, allowEmpty = false, }) => {
    // get the current form instance and the current value used to show/hide the feedback icon
    const form = Form.useFormInstance();
    const currentValue = Form.useWatch(name, form);
    return (React.createElement(Form.Item, { name: name, label: React.createElement(React.Fragment, null,
            React.createElement("span", { style: { marginRight: 5 } }, label),
            React.createElement(Tooltip, { title: "To enter multiple email addresses, use a comma (,) between each address.", color: "rgb(245, 245, 245)" },
                React.createElement(InfoCircleOutlined, null))), rules: [Validator.emails(allowEmpty)], validateTrigger: ["onChange"], hasFeedback: currentValue?.length > 0 },
        React.createElement(Select, { mode: "tags", style: { width: "100%" }, tokenSeparators: [","], open: false, placeholder: "Enter email addresses", tagRender: renderTag, disabled: disabled, maxLength: 320 })));
};
SecurePassMultiEmail.defaultProps = {
    name: "contactEmail",
    label: "Contact Emails",
    disabled: false,
    allowEmpty: false,
};
export default SecurePassMultiEmail;
